var map = {
	"./01.jpg": 6288,
	"./02.jpg": 639,
	"./03.jpg": 8930,
	"./04.jpg": 3537,
	"./05.jpg": 2852,
	"./06.jpg": 8915,
	"./07.jpg": 5782,
	"./08.jpg": 2325,
	"./09.jpg": 4456,
	"./10.jpg": 1910,
	"./11.jpg": 7171
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6025;